<template>
  <div id="totals" class="border-padding">
  <main>
    <div v-if="away_team != undefined" class="border-padding">
      <h2>{{ away_team }} @ {{ home_team }} - {{ date }}</h2>
      <p><router-link :to="{ name: 'assist_networks', params: { type: 'game', league: league }, query: { GameId: $route.params.game_id, TeamId: home_team_id}}">{{ home_team }} Assist Network</router-link></p>
      <p><router-link :to="{ name: 'assist_networks', params: { type: 'game', league: league }, query: { GameId: $route.params.game_id, TeamId: away_team_id}}">{{ away_team }} Assist Network</router-link></p>
    </div>

    <div class="row">
        <div class="col-md-2">
            <multiselect
            v-model="game_data_type_selected"
            select-label=""
            deselect-label=""
            track-by="id"
            label="text"
            @input="changeStats"
            :preselect-first="true"
            :options="game_data_type_dropdown"
            :searchable="false"
            :show-labels="false"
            :allow-empty="false">
            <template slot="singleLabel" slot-scope="{ option }">{{ option.text }}</template>
            </multiselect>
        </div>
    </div>

    <div v-if="loading">
      Loading.....
    </div>
    <p style="color:red;" v-if="show_error_message">Error Getting Results</p>

    <div v-if="table_data_options.length > 0 && period_keys.length > 0">
      <b-tabs>
        <div v-bind:key="period" v-for="period in period_keys">
          <b-tab :title="periodTitle(period)">
            <div class="col-md-2 border-padding">
              <stat-table-select v-model="stat_table_selected" :options="table_data_options"></stat-table-select>
            </div>
            <div v-if="stat_table_selected != undefined && multi_row_table_data_without_team.Away[period][stat_table_selected.id] != undefined">
              <h3>{{ away_team }}</h3>

              <vue-good-table
                :columns="multi_row_table_columns[stat_table_selected.id]"
                :rows="multi_row_table_data_without_team.Away[period][stat_table_selected.id]"
                :pagination-options="{ enabled: false}"
                :searchOptions="{ enabled: false}"
                :sort-options="{ enabled: true, initialSortBy: {field: 'Minutes', type: 'desc'}}"
                styleClass="vgt-table bordered striped">
                <template slot="table-row" slot-scope="props">
                  <div v-if="props.column.field == 'Name' || props.column.field == 'ShortName'">
                    <span :id="'popover-' + props.row.EntityId + period + '-' + stat_table_selected.id" v-b-tooltip.hover title="Click For More">
                      {{props.formattedRow[props.column.field]}}
                    </span>
                    <b-popover
                      :target="'popover-' + props.row.EntityId + period + '-' + stat_table_selected.id">
                      <template slot="title">{{props.row.Name}}</template>
                      <ul>
                        <li><router-link :to="{ name: 'game_logs', params: { league: league, type: $route.params.type }, query: {Season: season, SeasonType: season_type, EntityId: props.row.EntityId}}">Game Logs</router-link></li>
                        <li v-if="$route.params.type == 'lineup'"><router-link :to="{ name: 'totals', params: { league: league, type: 'lineup-player' }, query: {Season: season, SeasonType: season_type, LineupId: props.row.EntityId}}">Player Stats</router-link></li>
                        <li v-if="$route.params.type == 'lineup'"><router-link :to="{ name: 'assist_networks', params: { type: 'lineup', league: league }, query: { Season: season, SeasonType: season_type, LineupId: props.row.EntityId }}">Assist Network</router-link></li>
                      </ul>
                    </b-popover>
                  </div>
                  <div v-else>
                    <span v-b-tooltip.hover :title="props.row['Name']">
                      {{props.formattedRow[props.column.field]}}
                    </span>
                  </div>
                </template>
                <template slot="table-column" slot-scope="props">
                  <span v-if="props.column.hover != undefined" v-b-tooltip.hover :title="props.column.hover">
                    {{props.column.label}}
                  </span>
                  <span v-else>
                    {{props.column.label}}
                  </span>
                </template>
              </vue-good-table>

              <h3>{{ home_team }}</h3>

              <vue-good-table
                :columns="multi_row_table_columns[stat_table_selected.id]"
                :rows="multi_row_table_data_without_team.Home[period][stat_table_selected.id]"
                :pagination-options="{ enabled: false}"
                :searchOptions="{ enabled: false}"
                :sort-options="{ enabled: true, initialSortBy: {field: 'Minutes', type: 'desc'}}"
                styleClass="vgt-table bordered striped">
                <template slot="table-row" slot-scope="props">
                  <div v-if="props.column.field == 'Name' || props.column.field == 'ShortName'">
                    <span :id="'popover-' + props.row.EntityId + period + '-' + stat_table_selected.id" v-b-tooltip.hover title="Click For More">
                      {{props.formattedRow[props.column.field]}}
                    </span>
                    <b-popover
                      :target="'popover-' + props.row.EntityId + period + '-' + stat_table_selected.id">
                      <template slot="title">{{props.row.Name}}</template>
                      <ul>
                        <li><router-link :to="{ name: 'game_logs', params: { league: league, type: $route.params.type }, query: {Season: season, SeasonType: season_type, EntityId: props.row.EntityId}}">Game Logs</router-link></li>
                        <li v-if="$route.params.type == 'lineup'"><router-link :to="{ name: 'totals', params: { league: league, type: 'lineup-player' }, query: {Season: season, SeasonType: season_type, LineupId: props.row.EntityId}}">Player Stats</router-link></li>
                        <li v-if="$route.params.type == 'team'"><router-link :to="{ name: 'assist_networks', params: { type: 'team', league: league }, query: { Season: season, SeasonType: season_type, TeamId: props.row.EntityId }}">Assist Network</router-link></li>
                        <li v-if="$route.params.type == 'lineup'"><router-link :to="{ name: 'assist_networks', params: { type: 'lineup', league: league }, query: { Season: season, SeasonType: season_type, LineupId: props.row.EntityId }}">Assist Network</router-link></li>
                      </ul>
                    </b-popover>
                  </div>
                  <div v-else>
                    <span v-b-tooltip.hover :title="props.row['Name']">
                      {{props.formattedRow[props.column.field]}}
                    </span>
                  </div>
                </template>
                <template slot="table-column" slot-scope="props">
                  <span v-if="props.column.hover != undefined" v-b-tooltip.hover :title="props.column.hover">
                    {{props.column.label}}
                  </span>
                  <span v-else>
                    {{props.column.label}}
                  </span>
                </template>
              </vue-good-table>

              <h2>Team Totals</h2>

              <vue-good-table
                  :columns="single_row_table_columns[stat_table_selected.id]"
                  :rows="[single_row_table_data.Away[period]].concat(single_row_table_data.Home[period])"
                  :sort-options="{ enabled: false }"
                  styleClass="vgt-table bordered striped">
                  <template slot="table-row" slot-scope="props">
                  <span v-if="props.formattedRow[props.column.field] == ''">
                      0
                  </span>
                  <span v-else>
                      {{props.formattedRow[props.column.field]}}
                  </span>
                  </template>
                  <template slot="table-column" slot-scope="props">
                  <span v-if="props.column.hover != undefined" v-b-tooltip.hover :title="props.column.hover">
                      {{props.column.label}}
                  </span>
                  <span v-else>
                      {{props.column.label}}
                  </span>
                  </template>
              </vue-good-table>
            </div>
          </b-tab>
        </div>
      </b-tabs>
    </div>

  </main>
  </div>
</template>

<script>
import axios from 'axios'
import Multiselect from 'vue-multiselect'
import { rateStats } from './mixins/rate_stats'
import { tableDataOptions } from './mixins/table_data_options'
import { tableUtils } from './mixins/table_utils'
import { boxscoreHeaders } from './mixins/table_headers'
import StatTableSelect from './mixins/StatTableSelect.vue'

export default {
  name: 'GameStats',
  components: {
    Multiselect,
    StatTableSelect
  },
  mixins: [rateStats, tableDataOptions, tableUtils, boxscoreHeaders, StatTableSelect],
  data () {
    return {
      loading: false,
      game_data_type_dropdown: [
        {'id': 'player', 'text': 'Player'},
        {'id': 'lineup', 'text': 'Lineup'},
        {'id': 'lineup-opponent', 'text': 'Lineup Opponent'}
      ],
      game_data_type_selected: undefined,
      table_data_options: [],
      stat_table_selected: undefined,
      single_row_table_data: [],
      single_row_table_columns: {},
      multi_row_table_data: {},
      multi_row_table_columns: {},
      home_team: undefined,
      away_team: undefined,
      home_team_id: undefined,
      away_team_id: undefined,
      date: undefined,
      league: undefined,
      season_type: undefined,
      season: undefined,
      venue_keys: ['Away', 'Home'],
      period_keys: [],
      use_min_filters: false,
      use_text_filters: false,
      show_error_message: false,
      api_endpoint: 'get-game-stats'
    }
  },
  created () {
    this.game_data_type_dropdown.forEach((type) => {
      if (type.id === this.$route.params.type) {
        this.game_data_type_selected = type
      }
    })
    this.updateData()
  },
  watch: {
    '$route': 'updateData'
  },
  methods: {
    updateData () {
      if (this.$route.params.type && this.$route.params.game_id) {
        this.getStats()
      }
    },
    changeStats () {
      this.$router.push({name: 'game_stats', params: {type: this.game_data_type_selected.id, game_id: this.$route.params.game_id}})
    },
    getStats () {
      this.show_error_message = false
      this.multi_row_table_data = {}
      this.single_row_table_data = []
      this.table_data_options = []
      this.period_keys = []

      var params = {}

      if (this.$route.params.type === 'player') {
        params[this.$typeParam] = 'Player'
      } else if (this.$route.params.type === 'lineup') {
        params[this.$typeParam] = 'Lineup'
      } else if (this.$route.params.type === 'lineup-opponent') {
        params[this.$typeParam] = 'LineupOpponent'
      }
      params[this.$gameIdParam] = this.$route.params.game_id

      if (params[this.$gameIdParam] && params[this.$typeParam]) {
        this.loading = true
        axios.get(process.env.API_BASE_URL + this.api_endpoint, {
          params: params
        })
          .then((response) => {
            if (!response.data.error) {
              if (this.$route.params.type === 'player') {
                var tableHeaders = this.player_header
              } else {
                tableHeaders = this.lineups_header
              }
              this.single_row_table_data = response.data.team_results
              this.single_row_table_columns = tableHeaders

              this.multi_row_table_data = response.data.stats
              this.multi_row_table_columns = tableHeaders

              this.table_data_options = this.base_table_options
              this.date = response.data.date
              this.league = response.data.league
              this.season_type = response.data.season_type
              this.season = response.data.season
              this.home_team_id = response.data.home_team_id
              this.away_team_id = response.data.away_team_id
              this.home_team = response.data.home_team_abbreviation
              this.away_team = response.data.away_team_abbreviation

              this.multi_row_table_data_without_team = {}

              this.venue_keys.forEach((venue) => {
                this.multi_row_table_data_without_team[venue] = {}
                this.period_keys = Object.keys(this.multi_row_table_data[venue])
                this.period_keys.forEach((period) => {
                  this.multi_row_table_data_without_team[venue][period] = {}
                  this.multi_row_table_data[venue][period].forEach((row) => {
                    this.table_data_options.forEach((tableDataOption) => {
                      if (!this.multi_row_table_data_without_team[venue][period][tableDataOption.id]) {
                        this.multi_row_table_data_without_team[venue][period][tableDataOption.id] = []
                      }
                      var values = this.setZerosAndSortFunction(this.multi_row_table_columns[tableDataOption.id], row)
                      row = values.row
                      if (row.EntityId === '0' && tableDataOption.id !== 'Rebounds' && tableDataOption.id !== 'Turnovers') {
                        // team stats ie team rebounds set minutes as 0
                        row.Minutes = '0'
                      }
                      this.multi_row_table_columns[tableDataOption.id] = values.columns
                      var rowForTab = {}
                      this.multi_row_table_columns[tableDataOption.id].forEach((column) => {
                        if (!row[column.field]) {
                          rowForTab[column.field] = 0
                        } else {
                          rowForTab[column.field] = row[column.field]
                        }
                      })
                      if (row['EntityId']) {
                        rowForTab['EntityId'] = row['EntityId']
                      }
                      if (row['Name']) {
                        rowForTab['Name'] = row['Name']
                      }
                      if (row.EntityId !== '0' || tableDataOption.id === 'Rebounds' || tableDataOption.id === 'Turnovers') {
                        // only show row for team stats for rebounds and turnovers
                        this.multi_row_table_data_without_team[venue][period][tableDataOption.id].push(rowForTab)
                      }
                    })
                  })
                })
              })
            } else {
              this.show_error_message = true
              this.single_row_table_data = {}
              this.single_row_table_data_totals = []
            }
            this.loading = false
          }, (error) => {
            this.show_error_message = true
            this.loading = false
            this.error = error
          })
      }
    },
    periodTitle (period) {
      if (period === 'FullGame') {
        return 'Full Game'
      } else if (parseInt(period) > 4) {
        var ot = parseInt(period) - 4
        return 'OT' + ot.toString()
      } else if (period === '1') {
        return '1st Quarter'
      } else if (period === '2') {
        return '2nd Quarter'
      } else if (period === '3') {
        return '3rd Quarter'
      } else if (period === '4') {
        return '4th Quarter'
      }
    }
  }
}
</script>

<style scoped>
@import "https://maxcdn.bootstrapcdn.com/bootstrap/4.1.1/css/bootstrap.min.css"

</style>



// WEBPACK FOOTER //
// src/components/GameStats.vue